import { render } from "./PageB.vue?vue&type=template&id=4dd16809&scoped=true"
import script from "./PageB.vue?vue&type=script&lang=js"
export * from "./PageB.vue?vue&type=script&lang=js"

import "./PageB.vue?vue&type=style&index=0&id=4dd16809&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4dd16809"]])

export default __exports__